// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-xxxlargeOnConfiend-badge-aa20c890"};